import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BookingFormulaService } from './booking-formula.service'

@NgModule({
  imports: [CommonModule],
  providers: [BookingFormulaService],
})
export class BookingFormulaLibraryModule {}
